export enum LanguageType {
    EN = 'EN',
    ID_ID = 'ID_ID',
    TH_TH = 'TH_TH',
    ZH_CN = 'ZH_CN',
    VI_VN = 'VI_VN',
    MY_MM = 'MY_MM',
    JA_JP = 'JA_JP',
    KO_KR = 'KO_KR',
    HI_IN = 'HI_IN',
    KM_KH = 'KM_KH',
    PT_BR = 'PT_BR',
    BN_BD = 'BN_BD',
}
